import { CmsArticleStatusesEnum } from '~/src/models/enums/cms.enum';
import { fallBackOrder } from '~/src/repositories/cms/constants/cms.constants';
import type { DictionaryInterface } from '~/src/repositories/cms/types/cms.sections.types';
import type {
    CmsMainToolsBlockAttributeInterface,
    MainToolsBlockInterface,
} from '~/src/repositories/cms/entities/main/types/cms.main-tools-block.types';

export const getMappedMainToolsBlockData = (
    data: DictionaryInterface<CmsMainToolsBlockAttributeInterface>[] | [],
): MainToolsBlockInterface[] => {
    if (!data || !data.length) {
        return [];
    }

    const articles = data[0].articles || [];

    return articles
        .reduce<MainToolsBlockInterface[]>((mainToolsItem, elem) => {
            if (elem?.status === CmsArticleStatusesEnum.PUBLISHED) {
                const mainToolsList = elem.attributeCategories.instrumenty_dlya_vas?.attributes;
                mainToolsItem.push({
                    id: elem.id,
                    name: mainToolsList?.name?.value || null,
                    description: mainToolsList?.description?.value || null,
                    image: mainToolsList?.image?.value || null,
                    imageHover: mainToolsList?.image_hover?.value || null,
                    screens: mainToolsList?.screens?.value?.map((screen) => screen?.url) || null,
                    order: elem?.order || fallBackOrder,
                });
            }
            return mainToolsItem;
        }, [])
        .sort((item, elem) => (item?.order || fallBackOrder) - (elem?.order || fallBackOrder));
};
